import React, { createContext, useContext, useEffect, useState } from 'react';
import * as signalR from '@microsoft/signalr';
import { BASE_URL } from '../utils/config';
import { useStateSelector } from '../store/selectors';
import { useDispatch } from 'react-redux';
import { LoadCurrentUserIfNotSet } from '../slices/current-user/load-current-user-if-not-set.thunk';

interface ISignalRContext {
    connection: signalR.HubConnection | null;
    isConnected: boolean;
}

const SignalRContext = createContext<ISignalRContext>({
    connection: null,
    isConnected: false,
});

export const useSignalR = () => useContext(SignalRContext);

export const SignalRProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const dispatch = useDispatch() as any;
    const user = useStateSelector((s) => s.currentUser.user);
    const [connection, setConnection] = useState<signalR.HubConnection | null>(
        null
    );
    const [isConnected, setIsConnected] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            dispatch(LoadCurrentUserIfNotSet(true));
        }
    }, []);

    useEffect(() => {
        console.log(user);
        const token = localStorage.getItem('token');
        if (!user || user?.id === 0) {
            connection?.stop();
            setConnection(null);
            setIsConnected(false);
            return;
        }
        if (!token || (connection && isConnected)) return;

        let url = BASE_URL == '/' ? window.location.origin : BASE_URL;
        const hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(`${url}/hubs/vetvalue`, {
                accessTokenFactory: () => localStorage.getItem('token') ?? '',
                skipNegotiation: true,
                transport: signalR.HttpTransportType.WebSockets,
            })
            .withAutomaticReconnect({
                nextRetryDelayInMilliseconds: (retryContext) =>
                    retryContext.elapsedMilliseconds < 120000 ? 5000 : 30000,
            })
            .configureLogging(signalR.LogLevel.Warning)
            .build();

        hubConnection.onclose(() => {
            console.log('🔌 Connection closed');
            setIsConnected(false);
        });

        hubConnection.onreconnecting(() => {
            console.log('🔄 Reconnecting...');
            setIsConnected(false);
        });

        hubConnection.onreconnected(() => {
            console.log('✅ Reconnected');
            setIsConnected(true);
        });

        hubConnection
            .start()
            .then(() => {
                console.log('✅ SignalR connected');
                setConnection(hubConnection);
                setIsConnected(true);
            })
            .catch((err) => {
                console.error('❌ Connection failed: ', err);
                setIsConnected(false);
            });

        return () => {
            if (user) {
                // setIsConnected(false);
                // hubConnection.stop(); //ToDo 2.9: check if needed
            }
        };
    }, [user]);

    return (
        <SignalRContext.Provider value={{ connection, isConnected }}>
            {children}
        </SignalRContext.Provider>
    );
};
